const XlsType = 'application/vnd.ms-excel';
const XlsWpsType = 'application/wps-office.xls';
const XlsxType =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const CsvType = 'text/csv';
const dateFormat = 'DD/MM/YYYY';
const ddmmmmyyyy = 'DD MMMM YYYY';
const dateFormatWithHyphen = 'YYYY-MM-DD';
const ddmmyyyyhhmmss = 'DD-MM-YYYY HH:mm:ss';
const success = 'success';
const info = 'info';
const warning = 'warning';
const error = 'error';
const initialValuesQueryBuilder = {
  caseList: [],
  elseType: '',
  elseValue: '',
};
const a8Columns = [
  'a8_transaction_datetime',
  'a8_id',
  'a8_batch_id',
  'a8_created_at',
];
const allowTrim = ['number', 'decimal', 'date'];
const allowUppercase = ['number', 'decimal', 'date'];
const initialValues = {
  header_row: '1',
  header_column: 'A',
  data_row: '2',
  data_column: 'A',
  sync_type: 'manual',
  frequency_value: 0,
  max_number_of_retries: 0,
};
const messageDuration = 3;
const reviewer = 'reviewer';
const approver = 'approver';

const constants = {
  XlsType,
  XlsWpsType,
  XlsxType,
  CsvType,
  dateFormat,
  dateFormatWithHyphen,
  ddmmyyyyhhmmss,
  success,
  info,
  warning,
  error,
  initialValuesQueryBuilder,
  ddmmmmyyyy,
  a8Columns,
  allowTrim,
  allowUppercase,
  initialValues,
  messageDuration,
  reviewer,
  approver,
};

export default constants;
